"use strict";
import {
  scheduleStaleAppKitScrollLockCleanup,
  shortCircuitSameChainSwitch
} from "components/Web3Provider/walletConnectProviderFixes";
import {
  WALLET_CONNECT_STORAGE_PREFIX,
  purgeLegacyWalletConnectStorage
} from "components/Web3Provider/walletConnectStorage";
import { Z_INDEX } from "theme/zIndex";
import { walletConnect } from "wagmi/connectors";
if (process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID === void 0) {
  throw new Error("REACT_APP_WALLET_CONNECT_PROJECT_ID must be a defined environment variable");
}
const WALLET_CONNECT_PROJECT_ID = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID;
export const walletTypeToAmplitudeWalletType = (connectionType) => {
  switch (connectionType) {
    case "injected":
      return "Browser Extension";
    case "walletConnect":
      return "Wallet Connect";
    case "coinbaseWallet":
      return "Coinbase Wallet";
    case "binanceWallet":
      return "Binance Wallet";
    case "MetamaskWallet":
      return "Metamask Wallet";
    default:
      return connectionType ?? "Network";
  }
};
export const WC_PARAMS = {
  projectId: WALLET_CONNECT_PROJECT_ID,
  customStoragePrefix: WALLET_CONNECT_STORAGE_PREFIX,
  metadata: {
    name: "Topaz Dex",
    description: "Topaz Dex \u2014 the ve(3,3) decentralized exchange on BNB Chain.",
    url: window.location.origin,
    // Wallets (e.g. Safe) fetch these from their own context, so they must be absolute URLs
    icons: [`${window.location.origin}/logo.png`, `${window.location.origin}/apple-touch-icon.png`]
  },
  showQrModal: true,
  qrModalOptions: {
    themeVariables: {
      "--wcm-font-family": '"Nunito Sans", sans-serif',
      "--wcm-z-index": Z_INDEX.modal.toString()
    }
  }
};
const legacyStoragePurge = typeof window === "undefined" ? Promise.resolve([]) : purgeLegacyWalletConnectStorage(window.localStorage);
export function topazWalletConnect() {
  const createConnector = walletConnect(WC_PARAMS);
  return (config) => {
    const connector = createConnector(config);
    return {
      ...connector,
      async getProvider(parameters) {
        await legacyStoragePurge;
        return shortCircuitSameChainSwitch(await connector.getProvider.call(this, parameters));
      },
      async connect(parameters) {
        try {
          return await connector.connect.call(this, parameters);
        } finally {
          scheduleStaleAppKitScrollLockCleanup();
        }
      }
    };
  };
}
